const toDate = (value) => {
  if (!value) return null;
  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const getLastDayOfMonth = (year, month) =>
  new Date(year, month + 1, 0).getDate();

export const isLastDayOfMonth = (value) => {
  const date = toDate(value);
  if (!date) return true;
  return (
    date.getDate() === getLastDayOfMonth(date.getFullYear(), date.getMonth())
  );
};

export const clampDayOfMonth = (year, month, day) => {
  const lastDay = getLastDayOfMonth(year, month);
  const numericDay = Number(day);
  if (!Number.isInteger(numericDay) || numericDay < 1) return lastDay;
  return Math.min(numericDay, lastDay);
};

export const buildFinancialYearEndDate = (year, month, day) =>
  new Date(year, month, clampDayOfMonth(year, month, day));

/**
 * First day of a full 12-month basis period ending on `financialYearEnd`.
 * Month-end: 1 Jan for 31 Dec, 1 Jul for 30 Jun.
 * Other days: the day after the same date in the previous year
 * (16 Mar 2024 for 15 Mar 2025).
 */
export const getFullYearStartFromEnd = (financialYearEnd) => {
  const end = toDate(financialYearEnd);
  if (!end) return null;

  if (isLastDayOfMonth(end)) {
    return new Date(end.getFullYear(), end.getMonth() - 11, 1);
  }

  return new Date(end.getFullYear() - 1, end.getMonth(), end.getDate() + 1);
};
